import { FileText, Upload } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@/components/ds";
import { cn } from "@/lib/utils";

/** Shared information architecture for the rider library and ingestion flow. */
export function RidersWorkspaceHeader({ busy = false }: { busy?: boolean }) {
  const location = useLocation();
  const uploadActive = location.pathname === "/riders/upload";

  return (
    <header className="space-y-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-[26px] font-bold tracking-[-0.025em]" data-ds-display>
            Riders
          </h1>
          <p className="mt-1 text-sm text-ink-3">
            Keep source documents, extraction and review in one workspace.
          </p>
        </div>
        {busy && (
          <span className="mt-2 h-2 w-2 animate-pulse rounded-full bg-accent" aria-label="Updating riders" />
        )}
      </div>

      <nav className="ptabs" aria-label="Rider workspace">
        <Link
          to="/riders"
          className={cn("ptab", !uploadActive && "ptab--on")}
          aria-current={!uploadActive ? "page" : undefined}
        >
          <Icon icon={FileText} size={16} />
          Library
        </Link>
        <Link
          to="/riders/upload"
          className={cn("ptab", uploadActive && "ptab--on")}
          aria-current={uploadActive ? "page" : undefined}
        >
          <Icon icon={Upload} size={16} />
          Upload &amp; extract
        </Link>
      </nav>
    </header>
  );
}
